import { format } from 'date-fns';
import * as React from 'react';
import { connect } from 'react-redux';
import { actions } from 'react-redux-form';
import { withRouter } from 'react-router';
import * as PropTypes from 'prop-types'; 
import { IHistory } from '../../../interfaces';
import { PlantModel } from '../../../model/PlantModel';
import { QuestionModel } from '../../../model/QuestionModel';
import { parseJwt } from '../../../services/loginService';
import { getMonthlyFormQuestions, submitMonthlyForm } from '../../../services/monthlyFormService';
import { dispatch, marshallAnswers, checkAnswerForYesOrNo, getPageTitle } from '../../../utils/generalUtils';
import { Async } from '../../reusableComponents/Async';
import { BasePage } from '../../reusableComponents/BasePage';
import { ErrorPage } from '../../reusableComponents/ErrorPage';
import { Form } from '../../reusableComponents/FormComponents/Form';
import { FormFooter } from '../../reusableComponents/FormComponents/FormFooter';
import { InputRow } from '../../reusableComponents/FormComponents/InputRow';
import { ImageUpload } from '../../reusableComponents/ImageUpload';
import { Loader } from '../../reusableComponents/Loader';
import { RenderQuestion } from '../../reusableComponents/FormComponents/RenderQuestion';
import './monthlyForm.scss';
import { MonthlyFormModel } from '../../../model/MonthlyFormModel';

export interface IMonthlyUSTRectifierFormProps {
    questions: QuestionModel[];
    type: string;
    date: string;
    region: string;
    userName: string;
    userUID: string;
    history: IHistory;
    plantId: string;
    formId: string;
    formInstance: MonthlyFormModel;
    form;
}

export interface IMonthlyUSTRectifierFormState {
    date: string;
    answers: {
        quesName: string;
        answer: boolean;
    }[];
    isRectifierOn: boolean;
}

export class MonthlyUSTRectifierFormImpl extends
    React.PureComponent<IMonthlyUSTRectifierFormProps, IMonthlyUSTRectifierFormState> {
    constructor(props: IMonthlyUSTRectifierFormProps) {
        super(props);
        this.state = {
            answers: [], date: props.date, isRectifierOn: null
        };
    }
    loadDefaultValues = () => { 
        const answers = []; 
        if (this.props.formId) {
            this.props.questions.forEach(instance => {
                answers.push({
                    answer: instance.props.answer,
                    quesName: instance.props.question
                });
                dispatch(actions.change(`forms.monthlyUSTRect.${instance.props.quesNum}`,
                    checkAnswerForYesOrNo(instance.props.answer)));
            });
            this.setState({
                answers,
                isRectifierOn: ((answers[2] || {}).answer || '')
            });
        }
    }
    loadValues = () => {
        const answers = [];
        this.loadDefaultValues();
         dispatch(actions.change('forms.monthlyUSTRect.1', format(new Date(this.props.date), 'MM/DD/YYYY')));
         dispatch(actions.change('forms.monthlyUSTRect.2', this.props.userName));
    }

    promise = async () => {
        await getMonthlyFormQuestions(this.props.type, this.props.formId);
    }

    refs: {
        images: ImageUpload;
    };
    getChildContext() {
        return { formModel: 'forms.monthlyUSTRect' };
    } 

    static childContextTypes = {
        formModel: PropTypes.string
    };
    handleFormSubmit = (values) => {
        const answer = marshallAnswers(values);
        const data = {
            UserId: this.props.userUID,
            PlantId: this.props.plantId,
            InspectionID: 'MonthlyUSTRect',
            followUp_Required: false,
            Completed: true,
            Date: format(new Date(this.props.date), 'MM-DD-YYYY'),
            Answers: answer,
            followUp_form: 0,
            ImageUrls: [],
            DeletedImages : this.props.form.monthlyUSTRect.deletedImages || [],
            SignatureUrls: [],
            AssociatedTo: null
        };
        return submitMonthlyForm(data, this.props.history, this.refs.images.value, this.props.formId);
    }

    renderContent = () => {
        
        const Buttons = [{
            label: 'Yes',
            value: 'Yes'
        },
        {
            label: 'No',
            value: 'No'
        }
    ];
        const questions = [
            { question: 'Is the spill container lid intact?', name: 'question1' },
            { question: 'Is the spill container free of debris and/or liquid?', name: 'question2' },
            { question: 'Is the spill container free of cracks or holes?', name: 'question3' },
        ];
        const infoRows = [
            'Use this form to document operational checks of the cathodic protection system rectifier every month.',
            'If any significant variance is observed, please report this to the Environmental'
            + ' Manager so that any necessary repairs or adjustments can be made.',
            'This report will be kept in the corporate office for at least 5 years.',
            'Rectifier Manufacturer: Universal Rectifiers, Inc.',
            'Rectifier Model: Single Phase E5',
            'Rectifier Serial Number: 104993',
            'Rated DC Output: 20 volts; 5 amps',
        ];
        const { date, region, plantId, } = this.props;
        const plantInstance = PlantModel.get(plantId);
        return <Form
            loadDefaultValues={this.loadValues}
            onSubmit={this.handleFormSubmit}
            model="forms.monthlyUSTRect"
            className="monthly-ust-spill-form form"
        >
            <div className="information" >
                <h3>UST Rectifier Reading Form</h3>
                <ul>
                    {infoRows.map((infoData, index) => {
                        return <li key={index} >{infoData}</li>;
                    })}
                </ul>
            </div>
            <div className="plant-data" >Plant Region:&nbsp;&nbsp;<span><strong>{region}</strong></span></div>
            <div className="plant-data" >Plant ID: &nbsp;&nbsp;<span><strong>
                {plantInstance ? plantInstance.props.PlantId : ''}</strong></span></div>
            <div className="plant-data" >Date Inspected: &nbsp;&nbsp;<span>
                <strong>{format(new Date(this.props.date), 'MM-YYYY')}</strong>
            </span></div>
            <RenderQuestion
                    formId={this.props.formId}
                    key="3" 
                    quesNo="3"
                    question="Is Rectifier On"
                    questionType="YesNoType"
                    model="monthlyUSTRect"
                    customLabel=" "
                    buttons={Buttons}
                    isCheck={true}
                />
            <div className="question-heading" >DC Output</div>
            <div className="single-line-inputs" >
                <CustomInput
                    defaultValue={this.state.answers[3] ? this.state.answers[3].answer : ''}
                    type="text"
                    model=".4"
                    placeholder="Volts"
                    label="Volts:"
                />
                <CustomInput
                    defaultValue={this.state.answers[4] ? this.state.answers[4].answer : ''}
                    type="text"
                    model=".5"
                    placeholder="Amps"
                    label="Amps:"
                />
            </div>
            <div className="question-heading" >Tap Setting</div>
            <div className="single-line-inputs" >
                <CustomInput
                    defaultValue={this.state.answers[5] ? this.state.answers[5].answer : ''}
                    type="text"
                    model=".6"
                    placeholder="Coarse"
                    label="Coarse:"
                />
                <CustomInput
                    defaultValue={this.state.answers[6] ? this.state.answers[6].answer : ''}
                    type="text"
                    model=".7"
                    placeholder="Fine"
                    label="Fine:"
                />
            </div>
            
            <CustomInput
                    defaultValue={this.state.answers[7] ? this.state.answers[7].answer : ''}
                    type="textarea"
                    model=".8"
                    placeholder="Comment"
                    label="Comments:"
                />
            <ImageUpload
                ref="images"
                multi={true}
                label="Select Images to Upload:"
                defaultValue={this.props.formInstance && this.props.formInstance.props.ImageUrls }
            />
            <FormFooter />
        </Form>;
    }

    render() { 
        let pageTitle = `${getPageTitle(this.props.type, 'monthly', this.props.date, 'inspection')} `;
        return <BasePage pageTitle={pageTitle}>
            <Async
                identifier="MonthlyUSTRectifierForm"
                promise={this.promise}
                loader={<Loader type="async" />}
                content={this.renderContent()}
                error={<ErrorPage />}
            />
        </BasePage>;
    }

}
export function mapStateToProps(state, ownProps) {
    const type = 'MonthlyUSTRect';
    const date = ownProps.match.params.date;
    const region = ownProps.match.params.plantRegion;
    const plantId = ownProps.match.params.plantId;
    const userUID = state.login.get('UniqueId');
    const firstName = parseJwt(state.login.get('token')).First_Name;
    const lastName = parseJwt(state.login.get('token')).Last_Name;
    const questions = QuestionModel.getAllByType(type);
    const formInstance = MonthlyFormModel.get(ownProps.match.params.formId); 
    return {
        type, questions, date, region, plantId, userName: `${firstName} ${lastName}`, userUID,
        formId: ownProps.match.params.formId,form: state.forms, formInstance
    };
}
export const MonthlyUSTRectifierForm =
    withRouter(connect<{}, {}, IMonthlyUSTRectifierFormProps>(mapStateToProps)(MonthlyUSTRectifierFormImpl as any));

const CustomInput = ({ placeholder, model, type, label, defaultValue }) => {
    return <InputRow
        quesNo=""
        model={model}
        onChange={null}
        placeholder={placeholder}
        type={type}
        label={label}
        defaultValue={defaultValue}
    />;
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Forms/MonthlyForm/MonthlyUSTRectifierForm.tsx